import { createActionCreator } from 'deox';

import { TCreateBillingPortalSessionMaterials, TCreateBillingPortalSessionResponse } from '@/services/api/company';

// CONSTANTS

export enum ECreateBillingPortalSessionAction {
  CREATE_BILLING_PORTAL_SESSION = 'CREATE_BILLING_PORTAL_SESSION',
  CREATE_BILLING_PORTAL_SESSION_REQUEST = 'CREATE_BILLING_PORTAL_SESSION_REQUEST',
  CREATE_BILLING_PORTAL_SESSION_SUCCESS = 'CREATE_BILLING_PORTAL_SESSION_SUCCESS',
  CREATE_BILLING_PORTAL_SESSION_FAILED = 'CREATE_BILLING_PORTAL_SESSION_FAILED',
}

// TYPES

export type TCreateBillingPortalSessionRequest = {
  type: ECreateBillingPortalSessionAction.CREATE_BILLING_PORTAL_SESSION_REQUEST;
  payload: {
    materials: TCreateBillingPortalSessionMaterials;
    successCallback?: (response: TCreateBillingPortalSessionResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TCreateBillingPortalSessionSuccess = {
  type: ECreateBillingPortalSessionAction.CREATE_BILLING_PORTAL_SESSION_SUCCESS;
  payload: { response: TCreateBillingPortalSessionResponse };
};

export type TCreateBillingPortalSessionFailed = {
  type: ECreateBillingPortalSessionAction.CREATE_BILLING_PORTAL_SESSION_FAILED;
};

// FUNCTION

export const createBillingPortalSessionAction = {
  request: createActionCreator(
    ECreateBillingPortalSessionAction.CREATE_BILLING_PORTAL_SESSION_REQUEST,
    (resolve) =>
      (
        materials: TCreateBillingPortalSessionMaterials,
        successCallback?: (response: TCreateBillingPortalSessionResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TCreateBillingPortalSessionRequest =>
        resolve({ materials, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    ECreateBillingPortalSessionAction.CREATE_BILLING_PORTAL_SESSION_SUCCESS,
    (resolve) =>
      (response: TCreateBillingPortalSessionResponse): TCreateBillingPortalSessionSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    ECreateBillingPortalSessionAction.CREATE_BILLING_PORTAL_SESSION_FAILED,
    (resolve) =>
      (error: any): TCreateBillingPortalSessionFailed =>
        resolve({ error }),
  ),
};
